/**
 * API clients wrapper for auth-clientless-web-lite.
 * Adapted from @top/auth-block-api-clients
 */

import * as RestSDK from './rest-api-v2/sdk.gen'
import {
  CreatePartnerProfileUsingPostData,
  CreateSessionUsingPostData,
  GetLogoutForMvpdUsingGetData,
  GetProfileForCodeUsingGet1Data,
  GetProfileForMvpdUsingGetData,
  GetProfilesUsingGet1Data,
  GetSessionStatusUsingGet1Data,
  HandleRequestUsingGetData,
  ResumeSessionUsingPostData,
  RetrievePreAuthorizeDecisionsForMvpdUsingPost1Data,
  RetrieveVerificationTokenUsingPostData,
  StartAuthenticationUsingGetData,
  RetrieveAuthorizeDecisionsForMvpdUsingPostData,
} from './rest-api-v2/types.gen'

export { client as dcrApiclient } from './dcr-api/client.gen'
export { client as restApiV2client } from './rest-api-v2/client.gen'

// Wrap all the rest APIs up in one class
export class RestApiV2 {
  static Decisions = RestSDK.Decisions
  static Logout = RestSDK.Logout
  static Profiles = RestSDK.Profiles
  static Sessions = RestSDK.Sessions
  static Configuration = RestSDK.Configuration
  static PartnerSingleSignOn = RestSDK.PartnerSingleSignOn
}

// DCR APIs are already in one class
export { DynamicClientRegistrationApi } from './dcr-api/sdk.gen'

/**
 * All headers defined by Adobe. Not all endpoints will use all of them, but all of these should
 * be acceptable for CORS requests (access-control-allow-headers).
 */
export type RestApiV2Headers = Partial<
  | RetrieveAuthorizeDecisionsForMvpdUsingPostData['headers']
  | GetLogoutForMvpdUsingGetData['headers']
  | GetProfileForCodeUsingGet1Data['headers']
  | StartAuthenticationUsingGetData['headers']
  | HandleRequestUsingGetData['headers']
  | GetProfilesUsingGet1Data['headers']
  | CreatePartnerProfileUsingPostData['headers']
  | RetrieveVerificationTokenUsingPostData['headers']
  | CreateSessionUsingPostData['headers']
  | RetrievePreAuthorizeDecisionsForMvpdUsingPost1Data['headers']
  | GetSessionStatusUsingGet1Data['headers']
  | ResumeSessionUsingPostData['headers']
  | GetProfileForMvpdUsingGetData['headers']
>
